// extracted by mini-css-extract-plugin
module.exports = {"mention":"FormattedText_mention__36Vlz","link":"FormattedText_link__OySf1"};